













import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { mixins } from 'vue-class-component';
import BaseMixin from '@/misc/BaseMixin';

const MagazineStore = namespace('magazine');
const BookmarkStore = namespace('bookmark');

@Component({
    components: {
        LocationStatusComponent: () => import(
            /* webpackChunkName: "LocationStatusComponent" */
            '@/components/library/LocationStatus.component.vue'),
        LibraryComponent: () => import(
            /* webpackChunkName: "LibraryComponent" */
            '@/components/library/Library.component.vue'),
        CategoryMenuComponent: () => import(
            /* webpackChunkName: "CategoryMenuComponent" */
            '@/components/library/CategoryMenu.component.vue'),
        LanguageDialogComponent: () => import(
            /* webpackChunkName: "LanguageDialogComponent" */
            '@/components/library/LanguageDialog.component.vue')
    }
})
export default class LibraryView extends mixins(BaseMixin) {

    @MagazineStore.Mutation('resetSelectedMagazine')
    private resetSelectedMagazine!: () => void;

    @BookmarkStore.Action('validateAllBookmarksAction')
    private validateAllBookmarksAction!: () => void;

    get isShowRoomMode(): boolean {
        return process.env.VUE_APP_SHOW_ROOM_MODE === 'true';
    }

    public async mounted() {
        this.resetSelectedMagazine(); // Reset the store before opening the library
        this.setNavigationTitle({ title: this.$t('GENERAL.LIBRARY').toString() });
        this.validateAllBookmarksAction(); // Check all bookmarks and delete the old ones
    }
}
